import { CwsCarousel, CwsCarouselItem, CwsAligner } from '@components/cws'
import { ProductCard } from '@components/product'
import type { Product } from '@model/product'
import clsx from 'clsx'
import type { FC } from 'react'
import s from './ProductSlider.module.scss'
import { createRef, useMemo, useRef } from 'react'
import { useLimitTabToVisible } from '@ui/hooks/useLimitTabToVisible'

export interface ProductSliderProps {
  products: Product[]
  mainPageCollection?: boolean
  listName: string
}

const ProductSlider: FC<ProductSliderProps> = (props) => {
  const { products, listName } = props

  const sliderSize: { [keys: string]: string } = {
    1: s.carousel_for_one,
    2: s.carousel_for_twe,
    3: s.carousel_for_free,
  }

  const nonListProducts = products.filter((e) => !Array.isArray(e))
  const containerRef = useRef<HTMLDivElement>(null)

  const itemRefs = useMemo(() => nonListProducts.map(() => createRef<HTMLDivElement>()), [nonListProducts.length])

  useLimitTabToVisible(containerRef, itemRefs, 0.75)
  return (
    <CwsAligner>
      <CwsCarousel ref={containerRef as any} mode={'card'} className={clsx(sliderSize[`${nonListProducts.length}`])}>
        {nonListProducts.map((innerProduct, idx) => {
          const key = innerProduct.sku ?? idx
          return (
            <CwsCarouselItem key={key}>
              <div ref={itemRefs[idx]}>
                <ProductCard listName={listName} product={innerProduct} className={s.sliderCard} index={idx + 1} />
              </div>
            </CwsCarouselItem>
          )
        })}
      </CwsCarousel>
    </CwsAligner>
  )
}

export default ProductSlider
